import { Button, Message } from '@mairistem/composants';
import { ListeTable } from '@mairistem/liste';
import dayjs from 'dayjs';
import type { RecuListeItemType } from '@/types/recu';
import { formatMonetaire } from '@/utils';

// @ts-expect-error
import icon from '../../../assets/images/icon_recu_white.svg';

interface FacturesListeTableRowProps {
  item: RecuListeItemType;
  rowProps: Record<string, unknown>;
  onOpen: (identifiant: number) => void;
  /** Régie autonome : la notion de facture n'existe pas, la colonne/cellule est masquée. */
  autonome?: boolean;
}

const RecusListeTableRow = (props: FacturesListeTableRowProps) => {
  const { item, rowProps, onOpen, autonome } = props;

  const {
    identifiant,
    numero,
    nomPayeur,
    dateCreation,
    adressePayeur,
    numeroFacturesEncaissees,
    montant,
    annule,
    regisseur,
  } = item;

  const handleOpen = () => {
    onOpen(identifiant);
  };

  return (
    <ListeTable.Row key={identifiant} {...rowProps}>
      <ListeTable.Cell
        textAlign="right"
        name="numero"
        // @ts-expect-error
        onDoubleClick={handleOpen}
        title={numero}
      >
        {numero}
      </ListeTable.Cell>
      <ListeTable.Cell
        name="payeur"
        // @ts-expect-error
        title={nomPayeur}
        onDoubleClick={handleOpen}
      >
        {nomPayeur}
      </ListeTable.Cell>
      <ListeTable.Cell
        name="dateCreation"
        // @ts-expect-error
        onDoubleClick={handleOpen}
        textAlign="center"
      >
        {dayjs(dateCreation).format('DD/MM/YYYY')}
      </ListeTable.Cell>
      <ListeTable.Cell
        name="adressePayeur"
        // @ts-expect-error
        title={adressePayeur}
        onDoubleClick={handleOpen}
      >
        {adressePayeur}
      </ListeTable.Cell>
      {!autonome && (
        <ListeTable.Cell
          name="factures"
          // @ts-expect-error
          title={numeroFacturesEncaissees}
          onDoubleClick={handleOpen}
        >
          {numeroFacturesEncaissees}
        </ListeTable.Cell>
      )}
      <ListeTable.Cell
        name="montant"
        textAlign="right"
        // @ts-expect-error
        onDoubleClick={handleOpen}
      >
        {formatMonetaire(montant) || ''}
      </ListeTable.Cell>
      <ListeTable.Cell
        name="dateAnnulation"
        stretched
        // @ts-expect-error
        onDoubleClick={handleOpen}
      >
        <Message
          {...(annule && { color: 'red' })}
          attached
          style={{
            display: 'flex',
            height: '100%',
            width: '100%',
            margin: 0,
            border: 'none',
            boxShadow: 'none',
            borderRadius: 0,
            fontWeight: 500,
            padding: 0,
            ...(!annule && { background: 'transparent' }),
          }}
        >
          <span
            style={{
              flex: 1,
              overflowX: 'hidden',
              textOverflow: 'ellipsis',
              padding: '1.25em 1.5em',
            }}
          >
            {annule ? 'Annulé' : <>&nbsp;</>}
          </span>
        </Message>
      </ListeTable.Cell>
      <ListeTable.Cell
        name="regisseur"
        // @ts-expect-error
        title={regisseur}
        onDoubleClick={handleOpen}
        stretched
      >
        <div
          style={{
            display: 'flex',
            height: '100%',
            width: '100%',
            margin: 0,
            border: 'none',
            boxShadow: 'none',
            borderRadius: 0,
            padding: 0,
            backgroundColor: 'transparent',
          }}
        >
          <span
            style={{
              flex: 1,
              overflowX: 'hidden',
              textOverflow: 'ellipsis',
              padding: '1.25em 1.5em',
            }}
          >
            {regisseur}
          </span>
          <Button
            data-testid="liste-table-row-button-recu"
            className="liste-table-row-button"
            title="Accéder au reçu pour consultation, annulation ou réédition"
            onClick={handleOpen}
          >
            <img
              src={icon}
              style={{
                width: 30,
                height: 30,
              }}
              alt="icon_encaisser"
            />
          </Button>
        </div>
      </ListeTable.Cell>
    </ListeTable.Row>
  );
};

export default RecusListeTableRow;
